<template>
  <div class="control-desk"></div>
</template>
<script>
import { createUrl, getElectronicSignDetail } from '@/api/e-signature';

export default {
  name: 'ControlDesk',
  methods: {
    async init () {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      if (!userInfo || !userInfo.employeeMsg) {
        this.$message.error('请先登录');
        return;
      }

      const res = await getElectronicSignDetail({ tenantId: userInfo.tenantId });
      const authStatus = res?.body?.authStatus || 0;
      if (authStatus !== 4) {
        this.$message({
          message: '请等待企业电子签认证完成',
          type: 'warning',
          duration: 5000,
        });
        setTimeout(() => {
          this.$tabs.close(); // 关闭当前标签页
        }, 5000);
        return;
      }

      const { body } = await createUrl({
        employeeId: userInfo.employeeMsg.id,
      });
      if (!body || !body.consoleUrl) {
        this.$message.error('生成链接失败！');
        return;
      }
      this.$tabs.close(); // 关闭当前标签页
      window.open(body.consoleUrl, '_blank');
    },
  },
  created () {
    this.init();
  },
};
</script>
<style lang="scss" scoped>
.control-desk {
  height: 100%;
}
</style>
